import { render, staticRenderFns } from "./galeriTanimla.vue?vue&type=template&id=af8dbf16&scoped=true&"
import script from "./galeriTanimla.vue?vue&type=script&lang=js&"
export * from "./galeriTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8dbf16",
  null
  
)

export default component.exports